<template>
    <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
    <div v-else>
        <div class="cardBox">
            <div v-for="w in widgets" :key="w.id" >
                <Card :type="w.template.is_multiple ? 'sumCardBox' : 'listCardBox'" :cards="w.user_widgets" />
            </div>
        </div>
    </div>
</template>

<script>
    import Card from "../components/Cards"
    import jwt_decode from "jwt-decode";
    export default {
        name: 'Home',
        created: async function(){
            await this.$store.dispatch('getCustomWidgets', jwt_decode(localStorage.getItem('access_token')))
        },
        computed:{
            loading(){
                return this.$store.getters.getUserLoading
            },
            widgets(){
                return this.$store.getters.getCustomWidgets
            },
        },
      
        components:{
            Card
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/Home.vue